/**
 * Centralized localStorage key generators for onboarding v2 persistence.
 * These keys are shared across Onboarding.hook, BusinessInfo, FunnelSetup,
 * and OnboardingKnowledgeBase.hook — keep them in sync here.
 */

const PREFIX = 'onboarding_v2';

export function getStepKey(workspaceId: string): string {
  return `${PREFIX}_step_${workspaceId}`;
}

export function getCompletedKey(workspaceId: string): string {
  return `${PREFIX}_completed_${workspaceId}`;
}

export function getFunnelKey(workspaceId: string): string {
  return `${PREFIX}_funnel_${workspaceId}`;
}

export function getFunnelIdKey(workspaceId: string): string {
  return `${PREFIX}_funnelid_${workspaceId}`;
}

export function getBusinessInfoKey(workspaceId: string): string {
  return `${PREFIX}_businessinfo_${workspaceId}`;
}

export function getFunnelSetupKey(workspaceId: string): string {
  return `${PREFIX}_funnelsetup_${workspaceId}`;
}

export function getSmartLeadbotKey(workspaceId: string): string {
  return `${PREFIX}_smartleadbot_${workspaceId}`;
}

export function getWapiStateKey(workspaceId: string): string {
  return `${PREFIX}_wapistate_${workspaceId}`;
}

export function getPipeStagesKey(workspaceId: string): string {
  return `${PREFIX}_pipestages_${workspaceId}`;
}
